import React from "react";

const Home = () => {
  return (
    <div className="App" style={styles.background}>
      <div className="App-header"></div>
      <div style={styles.container}>
        <h1>Welcome to Joker Pro</h1>
        <p>Click on the links above to navigate the website.</p>
      </div>
    </div>
  );
};

const styles = {
  background: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "black",
  },
  container: {
    textAlign: "center",
    padding: "20px",
    borderRadius: "10px",
    maxWidth: "600px",
    backgroundColor: "#fff",
    fontFamily: "Courier, monospace",
    whiteSpace: "nowrap",
    overflow: "hidden",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  },
};

export default Home;
